module.exports = __webpack_public_path__ + "img/dtmslg-currency-guide-1.2c992b0e.png";